import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useWebSocket } from "../../contexts/WebSocketContext";
import QA from "./QA";
import Step1 from "./Step1";
import Stage3 from "./Stage3";
import TransferMarketPanel from "./TransferMarketPanel";
import LeaderboardModal from "./LeaderboardModal";
import PreviousLeaderboardModal from "./PreviousLeaderboardModal";
import TeamsModal from "./TeamsModal";
import BottomBar from "./BottomBar";
import { toast } from "react-toastify";
import axios from "axios";
import RoundTableModal from "./RoundTableModal";
import AccountInfoModal from "./AccountInfoModal";
import TeamAccountInfoModal from "./TeamAccountInfoModal";
import IndividualAnalysisPanel from "./IndividualAnalysisPanel/IndividualAnalysisPanel";
import Step2 from "./Step2";
import Stage4 from "./Stage4";
import CustomerTeamLeaderBoard from "./CustomerTeamLeaderBoard";

function CustomerDashboard() {
  const { isSocketConnected, socketError, socketData } = useWebSocket();
  const [activeTab, setActiveTab] = useState(null);
  const [showLeaderboardModal, setShowLeaderboardModal] = useState(false);
  const [showPreviousLeaderboardModal, setShowPreviousLeaderboardModal] =
    useState(false);
  const [showTransferMarket, setShowTransferMarket] = useState(false);
  const [showTeamsModal, setShowTeamsModal] = useState(false);
  const [teams, setTeams] = useState([]);
  const { user, logout, apiBaseUrl } = useAuth();

  console.log("user", user);

  const [currentStageId, setCurrentStageId] = useState(null);
  const [showRoundTableModal, setShowRoundTableModal] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [canClosePositions, setCanClosePositions] = useState(false);

  const [showTeamAccountModal, setShowTeamAccountModal] = useState(false);
  const [teamAccountData, setTeamAccountData] = useState(null);
  const [teamAccountLoading, setTeamAccountLoading] = useState(false);

  const [showIndividualAnalysis, setShowIndividualAnalysis] = useState(false);
  const [showTeamAnalysis, setShowTeamAnalysis] = useState(false);

  // 👇 State جدید برای مودال رده‌بندی تیمی
  const [showTeamLeaderboard, setShowTeamLeaderboard] = useState(false);

  useEffect(() => {
    if (socketData?.data?.stage_id) {
      const stageId = socketData.data.stage_id;
      setCurrentStageId(stageId);

      if (stageId == "1") {
        setActiveTab("stage1");
      } else if (
        (socketData.data.event == "question_started" ||
          socketData.data.event == "question_done") &&
        stageId == "2"
      ) {
        setActiveTab("qa");
      } else if (stageId == "2") {
        setActiveTab("stage2");
      } else if (stageId == "3") {
        setActiveTab("stage3");
      } else if (stageId == "4") {
        setActiveTab("stage4");
      } else if (stageId == "7") {
        setActiveTab("qa");
      } else {
        setActiveTab(null);
      }
    }
  }, [socketData]);

  useEffect(() => {
    if (socketData?.data) {
      const { stage_id, notification } = socketData.data;

      if (
        stage_id == 3 &&
        Array.isArray(notification) &&
        notification.includes("five_percent_exceeded")
      ) {
        axios
          .get(apiBaseUrl + "/api/tournament/user/five-percent", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            if (response.status == 200) {
              setCanClosePositions(true);
            }
          })
          .catch((error) => {
            console.error("❌ خطا در درخواست five-percent:", error);
            setCanClosePositions(false);
          });
      }
    }
  }, [socketData, apiBaseUrl]);

  const handleOpenTeamAnalysis = useCallback(async () => {
    setTeamAccountLoading(true);
    try {
      const response = await axios.get(apiBaseUrl + "/api/teams/user/me", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setTeamAccountData(response.data.data);
      setShowTeamAnalysis(true);
    } catch (error) {
      console.error("❌ خطا در دریافت اطلاعات تیم:", error);
      toast.error("خطا در دریافت اطلاعات حساب تیم");
    } finally {
      setTeamAccountLoading(false);
    }
  }, [apiBaseUrl]);

  const handleCloseTeamAnalysis = useCallback(() => {
    setShowTeamAnalysis(false);
  }, []);

  const handleCloseIndividualAnalysis = useCallback(() => {
    setShowIndividualAnalysis(false);
  }, []);

  const fetchTeamAccountData = async () => {
    setTeamAccountLoading(true);
    try {
      const response = await axios.get(apiBaseUrl + "/api/teams/user/me", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setTeamAccountData(response.data.data);
      setShowTeamAccountModal(true);
    } catch (error) {
      console.error("❌ خطا در دریافت اطلاعات تیم:", error);
      toast.error("خطا در دریافت اطلاعات حساب تیم");
    } finally {
      setTeamAccountLoading(false);
    }
  };

  const handleRequestRoundTable = () => {
    setShowRoundTableModal(true);
  };

  const confirmRoundTableRequest = () => {
    axios
      .post(apiBaseUrl + "/api/change-captain/user/initiate", {
        stage_id: currentStageId,
      })
      .then((response) => {})
      .catch((error) => {
        console.error("❌ خطا در درخواست میز گرد:", error);

        if (error.status == 409) {
          toast.error("در هر چالش شما مجاز به یک درخواست میز گرد هستید");
        } else if (error.status == 429) {
          toast.error("سقف درخواست های میز گرد شما پر شده است");
        } else {
          const errorMessage =
            error.response?.data?.message ||
            error.message ||
            "خطا در ارسال درخواست. لطفاً دوباره تلاش کنید.";
          toast.error(errorMessage);
        }
      });
  };

  const sidebarItems = [
    { id: "مرحله 1", label: "مرحله 1", icon: "💬" },
    { id: "qa", label: "پرسش و پاسخ", icon: "💬" },
    { id: "stage3", label: "مرحله 3", icon: "🎯" },
  ];

  const shouldShowRoundTableButton =
    isSocketConnected && currentStageId && currentStageId >= 2;

  const fetchTeams = async () => {
    try {
      const response = await fetch(apiBaseUrl + "/api/teams/user", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("خطا در دریافت اطلاعات تیم‌ها");
      }

      const data = await response.json();
      setTeams(data.data || []);
      setShowTeamsModal(true);
    } catch (error) {
      console.error("❌ خطا در دریافت تیم‌ها:", error);
      toast.error("خطا در دریافت اطلاعات تیم‌ها");
    }
  };

  const renderContent = () => {
    if (socketError && !isSocketConnected) {
      return (
        <div className="p-8 h-full flex items-center justify-center relative overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className="absolute rounded-full opacity-2 blur-3xl animate-pulse"
              style={{
                width: "400px",
                height: "400px",
                background:
                  "radial-gradient(circle, #dc2626 0%, transparent 70%)",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                animationDuration: "4s",
              }}
            ></div>
          </div>

          <div className="text-center relative z-10">
            <div
              className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
              style={{
                backgroundColor: "rgba(220, 38, 38, 0.2)",
                boxShadow: "0 0 40px rgba(220, 38, 38, 0.3)",
              }}
            >
              <span className="text-5xl">⚠️</span>
            </div>
            <p className="text-red-400 text-lg font-medium mb-2">
              خطا در اتصال به سرور
            </p>
            <p className="text-gray-500 text-sm mb-6">
              لطفاً اتصال اینترنت خود را بررسی کنید یا با پشتیبانی تماس بگیرید
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-xl text-white font-medium transition-all duration-300 hover:scale-105"
              style={{
                backgroundColor: "#dc2626",
                boxShadow: "0 4px 15px rgba(220, 38, 38, 0.3)",
              }}
            >
              تلاش مجدد
            </button>
          </div>
        </div>
      );
    }

    if (!activeTab) {
      return (
        <div className="p-8 h-full flex items-center justify-center relative overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className="absolute rounded-full opacity-2 blur-3xl animate-pulse"
              style={{
                width: "400px",
                height: "400px",
                background:
                  "radial-gradient(circle, #fd0d0e 0%, transparent 70%)",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                animationDuration: "4s",
              }}
            ></div>
          </div>

          <div className="text-center relative z-10">
            <div
              className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center animate-spin relative"
              style={{
                backgroundColor: "rgba(253, 13, 14, 0.2)",
                boxShadow: "0 0 40px rgba(253, 13, 14, 0.3)",
              }}
            >
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center"
                style={{ backgroundColor: "#1f2937" }}
              >
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: "#fd0d0e" }}
                ></div>
              </div>
            </div>
            <p className="text-gray-300 text-lg font-medium mb-2">
              در انتظار شروع...
            </p>
            <p className="text-gray-500 text-sm">
              سیستم آماده دریافت اطلاعات است
            </p>
          </div>
        </div>
      );
    }

    switch (activeTab) {
      case "qa":
        return <QA socketData={socketData || {}} />;
      case "stage1":
        return <Step1 />;
      case "stage2":
        return <Step2 />;
      case "stage3":
        return (
          <Stage3
            socketData={socketData || {}}
            canClosePositions={canClosePositions}
          />
        );
      case "stage4":
        return <Stage4 socketData={socketData || {}} />;
      default:
        return null;
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col relative overflow-hidden"
      style={{ direction: "rtl", backgroundColor: "#1f2937" }}
    >
      {/* Background animated gradient */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute rounded-full opacity-5 blur-3xl animate-pulse"
          style={{
            width: "800px",
            height: "800px",
            background: "radial-gradient(circle, #fd0d0e 0%, transparent 70%)",
            top: "-300px",
            right: "-200px",
            animationDuration: "8s",
          }}
        ></div>
        <div
          className="absolute rounded-full opacity-5 blur-3xl animate-pulse"
          style={{
            width: "600px",
            height: "600px",
            background: "radial-gradient(circle, #fd0d0e 0%, transparent 70%)",
            bottom: "-200px",
            left: "-100px",
            animationDuration: "10s",
            animationDelay: "2s",
          }}
        ></div>
      </div>

      {/* Header */}
      <header
        className="shadow-lg border-b backdrop-blur-xl z-20 relative"
        style={{
          backgroundColor: "rgba(17, 24, 39, 0.8)",
          borderColor: "rgba(55, 65, 81, 0.5)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
      >
        <div className="px-8 py-4 flex items-center justify-between relative">
          <div className="flex items-center gap-4">
            <div className="flex items-center">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center ml-3 transform transition-transform hover:scale-110"
                style={{
                  backgroundColor: "#fd0d0e",
                  boxShadow: "0 4px 15px rgba(253, 13, 14, 0.3)",
                }}
              >
                <span className="text-white text-xl">
                  {activeTab &&
                    sidebarItems.find((item) => item.id == activeTab)?.icon}
                </span>
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">
                  {activeTab
                    ? sidebarItems.find((item) => item.id === activeTab)?.label
                    : "در انتظار..."}
                </h1>
                <p className="text-xs text-gray-400">
                  پنل کاربری هلدینگ آهنگری
                </p>
              </div>
            </div>
          </div>

          <div className="absolute left-1/2 transform -translate-x-1/2">
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center overflow-hidden"
              style={{
                backgroundColor: "rgba(253, 13, 14, 0.1)",
                boxShadow: "0 0 30px rgba(253, 13, 14, 0.3)",
                backdropFilter: "blur(10px)",
              }}
            >
              <img
                src="/logo/ahangari-holding.svg"
                alt="Logo"
                className="w-12 h-12"
                style={{
                  filter: "drop-shadow(0 0 8px rgba(253, 13, 14, 0.4))",
                }}
              />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div
              className="flex items-center gap-3 px-4 py-2 rounded-xl backdrop-blur-sm border transition-all duration-300 hover:border-red-500/50"
              style={{
                backgroundColor: "rgba(31, 41, 55, 0.5)",
                borderColor: "rgba(55, 65, 81, 0.5)",
              }}
            >
              <div
                className="  rounded-full flex items-center justify-center transform transition-transform hover:scale-110"
                style={{
                  
                  boxShadow: "0 0 15px rgba(253, 13, 14, 0.3)",
                }}
              >
                <span className="text-white text-sm font-bold">
                  {user.kyc_information.first_name + " " + user.kyc_information.last_name}
                </span>
              </div>
            </div>

            <button
              onClick={() => logout()}
              className="px-5 py-2.5 text-sm text-gray-300 hover:text-white rounded-xl transition-all duration-300 flex items-center gap-2 backdrop-blur-sm border group"
              style={{
                backgroundColor: "rgba(31, 41, 55, 0.5)",
                borderColor: "rgba(55, 65, 81, 0.5)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(220, 38, 38, 0.2)";
                e.currentTarget.style.borderColor = "rgba(220, 38, 38, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(31, 41, 55, 0.5)";
                e.currentTarget.style.borderColor = "rgba(55, 65, 81, 0.5)";
              }}
            >
              <span className="font-medium">خروج</span>
              <svg
                className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="flex flex-1 relative z-10">
        <div className="flex-1 p-6 pb-24">
          <div
            className="rounded-3xl shadow-2xl border backdrop-blur-xl h-full overflow-hidden relative"
            style={{
              backgroundColor: "rgba(17, 24, 39, 0.6)",
              borderColor: "rgba(55, 65, 81, 0.4)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
            }}
          >
            <div
              className="absolute animate-float-horizontal"
              style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "700px",
                height: "700px",
                opacity: "0.08",
                filter: "blur(3px)",
                pointerEvents: "none",
                zIndex: 1,
              }}
            >
              <img
                src="/logo/ahangari-holding.svg"
                alt="Background Logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>

            <div
              className="absolute inset-0 opacity-5 pointer-events-none"
              style={{
                background:
                  "linear-gradient(135deg, #fd0d0e 0%, transparent 100%)",
                zIndex: 2,
              }}
            ></div>

            <div className="relative z-10 h-full">{renderContent()}</div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <BottomBar
        socketData={socketData}
        onPreviousLeaderboard={() => setShowPreviousLeaderboardModal(true)}
        onCurrentLeaderboard={() => setShowLeaderboardModal(true)}
        onTransferMarket={() => setShowTransferMarket(true)}
        onTeams={fetchTeams}
        onRequestRoundTable={
          shouldShowRoundTableButton
            ? handleRequestRoundTable
            : handleRequestRoundTable
        }
        onAccountInfo={() => setShowAccountModal(true)}
        onTeamAccountInfo={fetchTeamAccountData}
        onIndividualAnalysis={() => setShowIndividualAnalysis(true)}
        teamAccountData={teamAccountData}
        onTeamAnalysis={handleOpenTeamAnalysis}
        onTeamLeaderboard={() => setShowTeamLeaderboard(true)}
      />

      <IndividualAnalysisPanel
        show={showIndividualAnalysis}
        onClose={handleCloseIndividualAnalysis}
      />

      <IndividualAnalysisPanel
        show={showTeamAnalysis}
        onClose={handleCloseTeamAnalysis}
        teamAccountData={teamAccountData}
      />

      <TeamAccountInfoModal
        show={showTeamAccountModal}
        onClose={() => setShowTeamAccountModal(false)}
        teamData={teamAccountData}
        loading={teamAccountLoading}
      />

      {/* Modals & Panels */}
      <TransferMarketPanel
        show={showTransferMarket}
        onClose={() => setShowTransferMarket(false)}
      />

      <LeaderboardModal
        show={showLeaderboardModal}
        onClose={() => setShowLeaderboardModal(false)}
      />

      <PreviousLeaderboardModal
        show={showPreviousLeaderboardModal}
        onClose={() => setShowPreviousLeaderboardModal(false)}
      />

      <TeamsModal
        show={showTeamsModal}
        onClose={() => setShowTeamsModal(false)}
        teams={teams}
      />

      <RoundTableModal
        show={showRoundTableModal}
        onClose={() => setShowRoundTableModal(false)}
        onConfirm={confirmRoundTableRequest}
      />

      <AccountInfoModal
        show={showAccountModal}
        onClose={() => setShowAccountModal(false)}
        user={user}
      />

      {/* 👇 مودال رده‌بندی تیمی - Full Screen */}
      {showTeamLeaderboard && (
        <div
          className="fixed inset-0 z-50 flex flex-col"
          style={{ backgroundColor: "#1f2937" }}
        >
          {/* Header */}
          <div
            className="flex items-center justify-between px-8 py-2 border-b backdrop-blur-xl"
            style={{
              backgroundColor: "rgba(17, 24, 39, 0.9)",
              borderColor: "rgba(55, 65, 81, 0.5)",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
            }}
          >
            <h2 className="text-2xl font-bold text-white flex items-center gap-3">
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center"
                style={{
                  backgroundColor: "rgba(253, 13, 14, 0.2)",
                  boxShadow: "0 0 20px rgba(253, 13, 14, 0.3)",
                }}
              >
                <span className="text-2xl">🏆</span>
              </div>
              رده‌بندی تیمی
            </h2>
            <button
              onClick={() => setShowTeamLeaderboard(false)}
              className="w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 group"
              style={{
                backgroundColor: "rgba(55, 65, 81, 0.3)",
                border: "1px solid rgba(55, 65, 81, 0.5)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(220, 38, 38, 0.2)";
                e.currentTarget.style.borderColor = "rgba(220, 38, 38, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(55, 65, 81, 0.3)";
                e.currentTarget.style.borderColor = "rgba(55, 65, 81, 0.5)";
              }}
            >
              <svg
                className="w-6 h-6 text-gray-400 group-hover:text-red-400 transition-colors"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Content - Full Screen */}
          <div className="flex-1 overflow-y-auto p-8">
            <CustomerTeamLeaderBoard />
          </div>
        </div>
      )}

      <style>{`
        @keyframes floatHorizontal {
          0%, 100% {
            transform: translate(-50%, -50%) translateX(-30px);
          }
          50% {
            transform: translate(-50%, -50%) translateX(30px);
          }
        }

        .animate-float-horizontal {
          animation: floatHorizontal 8s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}

export default CustomerDashboard;